import React from 'react';
import PropTypes from 'prop-types';
import {graphql} from 'gatsby';

import Post from '../models/Post';

import Layout from '../components/Layout';
import Article from '../components/Article';

import About from '../components/About';
import CurrentCampaign from '../components/CurrentCampaign';

export default function render({data}) {
  return (
    <Layout solidHeader={true}>
      <Article post={Post.fromMD(data.markdownRemark)} />
      <CurrentCampaign />
      <About />
    </Layout>
  );
}

render.propTypes = {
  data: PropTypes.object,
};

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      ...MDPost
    }
  }
`;
